import { createFileRoute } from '@tanstack/react-router';

import { redirectIdManagementsToIds } from '@/lib/navigation/redirects';

export const Route = createFileRoute('/_staff/id-managements/$')({
  beforeLoad: ({ location }) => redirectIdManagementsToIds(location),
});
